import { userService } from 'common/services/user.service';

export const usePermission = (permission: string) => {
  return userService.hasAccess([permission]);
};
